import {Resource} from '@raison/types';
import {balancesRoutine} from './balancesRoutine';
import {BalancesSchema} from './balancesTypes';

const initialState: Resource<BalancesSchema> = Resource.from({isUninitialized: true});

type BalancesAction =
    | ReturnType<typeof balancesRoutine.success>
    | ReturnType<typeof balancesRoutine.failure>
    | ReturnType<typeof balancesRoutine.trigger>;

export default function (state = initialState, action: BalancesAction): Resource<BalancesSchema> {
    if (balancesRoutine.success.match(action)) {
        return Resource.from({isSuccess: true, data: action.payload, isFetching: false});
    }
    if (balancesRoutine.trigger.match(action)) {
        if (!state.data) {
            return Resource.from({isLoading: true});
        } else {
            return Resource.from({isFetching: true, isSuccess: true, data: state.data});
        }
    }
    if (balancesRoutine.failure.match(action)) {
        return Resource.from({isError: true, error: action.payload});
    }
    return state;
}
